import { TIMESLOT_ADD, TIMESLOT_EDIT, TIMESLOT_DELETE } from '../../constants/types';

export function addTimeSlot(newTimeSlot) {
  return {
    type: TIMESLOT_ADD,
    newTimeSlot,
  };
}

export function editTimeSlot(updatedTimeSlot) {
  return {
    type: TIMESLOT_EDIT,
    updatedTimeSlot,
  };
}

export function deleteTimeSlot(timeSlotName) {
  return {
    type: TIMESLOT_DELETE,
    timeSlotName,
  };
}
